import React, { useState, useContext, useEffect } from "react";
import Tabs from "../../../CommonComponents/Tabs";
import Attendance from "../../Dashboard/Widgets/AttendancendAssignmentStatus";
import LeaderBoardndPercentile from "../../Dashboard/Widgets/LeaderBoardndPercentile";
import Scores from "../../Dashboard/Widgets/Scores";
import AlertContext from "../../../../context/AlertContext";
// import { getDataFromStorage } from "../../../../util";
import { useParams, useSearchParams } from "react-router-dom";
import TimeSpent from "../Report/TimeSpent";
import { UserReportProvider } from "../../../../context/UserReportContext";
// import ComingSoonImg from "../../../../assets/images/ComingSoon.jpg";
import CodingChallengeReport from "./CodingChallengeReport";
import MockTestReport from "./MockTestReport";
import AiInterviewReport from "./AiInterviewReport";
import constants from "../../../../constants.js";
import TabList from "../../../CommonComponents/TabList.js";
import Tab from "../../../CommonComponents/Tab.js";
import TabPanels from "../../../CommonComponents/TabPanels.js";
import TabPanel from "../../../CommonComponents/TabPanel.js";
// const ComingSoon = () => {
//   return (
//     <div
//       style={{
//         textAlign: "center",
//         marginTop: "100px",
//         color: "#667085",
//         fontSize: "18px",
//         fontWeight: "500",
//         fontFamily: "Inter",
//       }}
//     >
//       <img src={ComingSoonImg} alt="Coming Soon" className="comingSoonImg" />
//       <p>Coming Soon!</p>
//     </div>
//   );
// };

const BatchDashboardReports = () => {
  const Alert = useContext(AlertContext);
  const { id } = useParams();
  const [_, setSearchParams] = useSearchParams();

  const stored = localStorage.getItem("account_response");
  const [enabledFeatures, setEnableFeatures] = useState([]);
  const [activeTab, setActiveTab] = useState(
    constants.BATCH_TYPE.TESTING ===
      Number(localStorage.getItem("batchType"))
      ? constants.ACCOUNT_TYPE.CORPORATE ===
        Number(localStorage.getItem("university_type"))
        ? "assignment-status" : "leaderboard"
        : "attendance"
  );
  const [refreshDashboard, setRefreshDashboard] = useState(false);

  useEffect(() => {
    if (stored) {
      try {
        const decoded = JSON.parse(atob(stored));
        // axios response structure
        // const companies = decoded || {};

        // const companyId = parseInt(getDataFromStorage("companyId"), 10);

        const selectedCompany = decoded || {};
        if (selectedCompany && selectedCompany.premium_features) {
          const features = JSON.parse(selectedCompany.premium_features);
          setEnableFeatures(
            features.map(
              (feature) =>
                feature.premium_feature_name ??
                feature.name ??
                feature.premium_features,
            ),
          );
          localStorage.setItem(
            "enabled_features",
            btoa(JSON.stringify(features)),
          );
        }
      } catch (error) {
        console.error("Error decoding accounts_response:", error);
      }
    }
  }, [stored]);

  // Tab configuration
  const tabs = [
    {
      id: "attendance",
      label: "Attendance",
      show:
        constants.BATCH_TYPE.TESTING !==
        Number(sessionStorage.getItem("batchType")),
      content: (
        <Attendance
          key="batch-attendance-report"
          name={Alert.batchDetails?.name}
          setRefresh={setRefreshDashboard}
          refresh={refreshDashboard}
          data={{ type: 1, name: "Attendance" }}
          dashboardId={1}
          batchId={Alert.batchDetails?.id || id}
          batchDashboard={true}
          batchStartDate={Alert.batchDetails?.startdate}
        />
      ),
    },
    {
      id: "leaderboard",
      label: "Leaderboard",
      show:
        Number(localStorage.getItem("university_type")) !==
        constants.ACCOUNT_TYPE.CORPORATE,
      content: (
        <LeaderBoardndPercentile
          key="batch-leaderboard-report"
          name={Alert.batchDetails?.name}
          setRefresh={setRefreshDashboard}
          refresh={refreshDashboard}
          data={{ type: 2, name: "Leaderboard" }}
          dashboardId={1}
          batchId={Alert.batchDetails?.id || id}
          batchDashboard={true}
          batchStartDate={Alert.batchDetails?.startdate}
        />
      ),
    },
    {
      id: "percentile",
      label: "Percentile",
      show:
        Number(localStorage.getItem("university_type")) !==
        constants.ACCOUNT_TYPE.CORPORATE,
      content: (
        <LeaderBoardndPercentile
          key="batch-percentile-report"
          name={Alert.batchDetails?.name}
          setRefresh={setRefreshDashboard}
          refresh={refreshDashboard}
          data={{ type: 3, name: "Percentile" }}
          dashboardId={1}
          batchId={Alert.batchDetails?.id || id}
          batchDashboard={true}
          batchStartDate={Alert.batchDetails?.startdate}
        />
      ),
    },
    {
      id: "assignment-status",
      label: "Assignment Status",
      content: (
        <Attendance
          key="batch-assignment-status-report"
          name={Alert.batchDetails?.name}
          setRefresh={setRefreshDashboard}
          refresh={refreshDashboard}
          data={{ type: 4, name: "Assignment Status" }}
          dashboardId={1}
          batchId={Alert.batchDetails?.id || id}
          batchDashboard={true}
          batchStartDate={Alert.batchDetails?.startdate}
        />
      ),
    },
    {
      id: "test-scores",
      label: "Test Scores",
      content: (
        <Scores
          name={Alert.batchDetails?.name}
          setRefresh={setRefreshDashboard}
          refresh={refreshDashboard}
          data={{ type: 5, name: "Test Scores" }}
          dashboardId={1}
          batchId={Alert.batchDetails?.id || id}
          batchDashboard={true}
          batchStartDate={Alert.batchDetails?.startdate}
        />
      ),
    },
    {
      id: "time-spent",
      label: "Time Spent",
      show:
        constants.BATCH_TYPE.TESTING !==
          Number(sessionStorage.getItem("batchType")) &&
        Number(localStorage.getItem("university_type")) !==
          constants.ACCOUNT_TYPE.CORPORATE,
      content: (
        <UserReportProvider>
          <TimeSpent data={{ type: 6, name: "Time Spent" }} />
        </UserReportProvider>
      ),
    },
    {
      id: "mock-test",
      label: "Mock Test",
      show:
        (enabledFeatures.includes("mcq") ||
          enabledFeatures.includes("descriptive") ||
          enabledFeatures.includes("coding_challenge_test") ||
          enabledFeatures.includes("video_test")) &&
        Number(localStorage.getItem("university_type")) !==
          constants.ACCOUNT_TYPE.CORPORATE,
      content: (
        <MockTestReport fromPage="reportpage" className={"reportpage"} />
      ),
    },
    {
      id: "coding-challenges",
      label: "Coding Challenges",
      show:
        enabledFeatures.includes("coding_challenges") &&
        Number(localStorage.getItem("university_type")) !==
          constants.ACCOUNT_TYPE.CORPORATE,
      content: (
        <CodingChallengeReport fromPage="reportpage" className={"reportpage"} />
      ),
    },
    {
      id: "ai-interviews",
      label: "AI Interviews",
      show:
        enabledFeatures.includes("ai_interviews") &&
        Number(localStorage.getItem("university_type")) !==
          constants.ACCOUNT_TYPE.CORPORATE,
      content: (
        <AiInterviewReport fromPage="reportpage" className={"reportpage"} />
      ),
    },
  ];

  // const visibleTabs = tabs.filter(tab => tab.show !== false);
  const visibleTabs = tabs
    .filter((tab) => tab.show !== false)
    .map((tab) => ({
      ...tab,
      onChange: () => Alert.setClickedMenu(1),
    }));

  const onChangeTab = (value) => {
    setActiveTab(value);
    setSearchParams({ "scope-ar": value });
  };

  return (
    <div className="batch-report-page-container" id="batch-report-page-container">
      <Tabs
        className="batch-report-tabs"
        value={activeTab}
        onChange={onChangeTab}
      >
        <TabList>
          {visibleTabs.map((item) => (
            <Tab
              key={item.id}
              value={item.id}
              className="batch-reports-tabs-tab"
            >
              {item.label}
            </Tab>
          ))}
        </TabList>
        <TabPanels className="batch-report-tab-pannels">
          <TabPanel value="attendance">
            <Attendance
              key="batch-attendance-report"
              name={Alert.batchDetails?.name}
              setRefresh={setRefreshDashboard}
              refresh={refreshDashboard}
              data={{ type: 1, name: "Attendance" }}
              dashboardId={1}
              batchId={Alert.batchDetails?.id || id}
              batchDashboard={true}
              batchStartDate={Alert.batchDetails?.startdate}
            />
          </TabPanel>
          <TabPanel value="leaderboard">
            <LeaderBoardndPercentile
              key="batch-leaderboard-report"
              name={Alert.batchDetails?.name}
              setRefresh={setRefreshDashboard}
              refresh={refreshDashboard}
              data={{ type: 2, name: "Leaderboard" }}
              dashboardId={1}
              batchId={Alert.batchDetails?.id || id}
              batchDashboard={true}
              batchStartDate={Alert.batchDetails?.startdate}
            />
          </TabPanel>
          <TabPanel value="percentile">
            <LeaderBoardndPercentile
              key="batch-percentile-report"
              name={Alert.batchDetails?.name}
              setRefresh={setRefreshDashboard}
              refresh={refreshDashboard}
              data={{ type: 3, name: "Percentile" }}
              dashboardId={1}
              batchId={Alert.batchDetails?.id || id}
              batchDashboard={true}
              batchStartDate={Alert.batchDetails?.startdate}
            />
          </TabPanel>
          <TabPanel value="assignment-status">
            <Attendance
              key="batch-assignment-status-report"
              name={Alert.batchDetails?.name}
              setRefresh={setRefreshDashboard}
              refresh={refreshDashboard}
              data={{ type: 4, name: "Assignment Status" }}
              dashboardId={1}
              batchId={Alert.batchDetails?.id || id}
              batchDashboard={true}
              batchStartDate={Alert.batchDetails?.startdate}
            />
          </TabPanel>
          <TabPanel value="test-scores">
            <Scores
              name={Alert.batchDetails?.name}
              setRefresh={setRefreshDashboard}
              refresh={refreshDashboard}
              data={{ type: 5, name: "Test Scores" }}
              dashboardId={1}
              batchId={Alert.batchDetails?.id || id}
              batchDashboard={true}
              batchStartDate={Alert.batchDetails?.startdate}
            />
          </TabPanel>
          <TabPanel value="time-spent">
            <UserReportProvider>
              <TimeSpent data={{ type: 6, name: "Time Spent" }} />
            </UserReportProvider>
          </TabPanel>
          <TabPanel value="mock-test">
            <MockTestReport fromPage="reportpage" className={"reportpage"} />
          </TabPanel>
          <TabPanel value="coding-challenges">
            <CodingChallengeReport
              fromPage="reportpage"
              className={"reportpage"}
            />
          </TabPanel>
          <TabPanel value="ai-interviews">
            <AiInterviewReport fromPage="reportpage" className={"reportpage"} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  );
};

export default BatchDashboardReports;
